import { useCallback, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { CONTEST_POPUP_DELAY_MS, CONTEST_POPUP_DISMISSED_KEY } from '../lib/contest'

const EXCLUDED_PREFIXES = ['/login', '/panel', '/admin', '/reset-hasla', '/link-bio'] as const

function isStored(key: string): boolean {
  try {
    return typeof window !== 'undefined' && sessionStorage.getItem(key) === '1'
  } catch {
    return false
  }
}

function pathExcluded(pathname: string): boolean {
  return EXCLUDED_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`))
}

export function useContestPromoPopup(): { open: boolean; dismiss: () => void } {
  const { pathname } = useLocation()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (pathExcluded(pathname)) return
    if (isStored(CONTEST_POPUP_DISMISSED_KEY)) return

    let cancelled = false
    const timerId = window.setTimeout(() => {
      if (cancelled) return
      if (isStored(CONTEST_POPUP_DISMISSED_KEY)) return
      setOpen(true)
    }, CONTEST_POPUP_DELAY_MS)

    return () => {
      cancelled = true
      window.clearTimeout(timerId)
    }
  }, [pathname])

  const dismiss = useCallback(() => {
    try {
      sessionStorage.setItem(CONTEST_POPUP_DISMISSED_KEY, '1')
    } catch {
      /* ignore */
    }
    setOpen(false)
  }, [])

  return { open, dismiss }
}
